import { Button } from '@/components/ui/button'
import { DataSourceCard } from '@/components/DataSources/data-source-card'
import type { WorkspaceDataSource } from 'honeygrid-types'
import { Upload, Plus } from 'lucide-react'

interface DataSourcesCardsProps {
	dataSources: WorkspaceDataSource[]
	onSelectDataSource: (ds: WorkspaceDataSource) => void
	onAddDataSource: () => void
	selectedDataSourceId?: string | number
	onDeleteDataSource?: (id: string | number) => void
}

export function DataSourcesCards({ dataSources, onSelectDataSource, onAddDataSource, selectedDataSourceId, onDeleteDataSource }: DataSourcesCardsProps) {
	if (dataSources.length === 0) {
		return (
			<div className="flex flex-col items-center justify-center text-center space-y-3 bg-[#3A2E2F]/5 h-40 py-8">
				<div className="h-8 w-8 shrink-0 flex items-center justify-center">
					<Upload className="h-8 w-8 text-foreground/60" />
				</div>
				<p className="text-sm font-medium text-muted-foreground">No data sources yet</p>
				<Button variant="outline" size="sm" onClick={onAddDataSource}>
					<Plus className="h-4 w-4 mr-2" />
					Add Data Source
				</Button>
			</div>
		)
	}

	return (
		<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
			{dataSources.map((ds) => (
				<DataSourceCard
					key={ds.id}
					dataSource={ds}
					selected={selectedDataSourceId === ds.id}
					onClick={() => onSelectDataSource(ds)}
					onViewDetails={() => onSelectDataSource(ds)}
					onDelete={(id) => onDeleteDataSource ? onDeleteDataSource(id) : void 0}
				/>
			))}
		</div>
	)
}


